import { defineStore } from 'pinia';
import type { User } from '@devhacker/shared/features/user/types/user';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { fetchMergedUser } from './api';

export const useUserStore = wrapPiniaStore(
  defineStore('user', {
    state: () => ({
      userData: null as null | User,
      // по умолчанию считаем, что запрашиваем данные, чтобы на клиенте сразу отображался лоадер
      isUserFetching: true,
      isSendRefreshToken: false, // идет обновление рефреш токена
      isLoggedInWp: false,
      afterLoginAction: undefined as undefined | (() => unknown),
    }),

    actions: {
      setIsLoggedInWp(isLoggedInWp: boolean) {
        this.isLoggedInWp = isLoggedInWp;
      },

      setUserRT(isSend: boolean) {
        this.isSendRefreshToken = isSend;
      },

      setUser(userData: User) {
        this.userData = userData;
        this.isUserFetching = false;
      },

      patchUser(userData: Partial<User>) {
        if (!this.userData) return;
        this.userData = { ...this.userData, ...userData };
      },

      clearUser() {
        this.userData = null;
      },

      async fetchUser(subId: string): Promise<User> {
        this.isUserFetching = true;

        try {
          const userData = await fetchMergedUser(subId);
          this.setUser(userData);
          return userData;
        } catch (error) {
          this.isUserFetching = false;
          throw error;
        }
      },
    },
  }),
);
